import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { getStateStyle } from './stateStyles';
import { buildTimeline } from './historyUtils';

const ChangeRow = ({ label, value, inline }) => (
    <div className={inline ? 'my-1.5 flex flex-wrap items-center gap-2' : 'my-1.5'}>
        <div className={`font-bold text-colorfourth ${inline ? '' : 'mb-0.5'}`}>{label}</div>
        {value === null || value === '' ? (
            <span className="italic text-gray-400">No asignado (—)</span>
        ) : (
            <span className="text-gray-600 [overflow-wrap:anywhere]">{value}</span>
        )}
    </div>
);

const TimelineEvent = ({ event }) => {
    const { color, Icon, chip } = getStateStyle(event.state);

    return (
        <div className="relative pl-11 mb-4">
            <div
                className="absolute left-0 top-1 w-7 h-7 rounded-full flex items-center justify-center ring-4 ring-white"
                style={{ backgroundColor: color }}
            >
                <Icon width={16} height={16} color="#fff" className="block" />
            </div>
            <div className="border border-colorfifth rounded-xl p-3 bg-white">
                <div className="font-bold text-colorfourth">{event.title}</div>
                <div className="text-sm text-gray-400 mt-0.5">{event.date}</div>
                <span className={`inline-block mt-1 px-2 rounded-md border text-xs font-semibold uppercase whitespace-nowrap ${chip}`}>
                    {event.state}
                </span>
                <div className="text-sm text-gray-500 mt-1">{event.user} · {event.type}</div>
                {event.changes.length > 0 && (
                    <div className="bg-colorsixth border border-colorfifth rounded-lg px-3 py-2 mt-2.5 text-sm">
                        {event.changes.map((change) => (
                            <ChangeRow key={change.key} label={change.label} value={change.value} inline={change.inline} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const Message = ({ children }) => <p className="text-center text-gray-500 py-6">{children}</p>;

export const HistoricalModal = ({ onHide, records, status }) => {
    const timeline = useMemo(() => buildTimeline(records), [records]);

    return (
        <Modal show onHide={onHide} dialogClassName="!max-w-[680px]" centered scrollable>
            <Modal.Header className="!justify-center !border-0">
                <h2 className="text-xl font-semibold text-center text-colorfourth">Histórico de la solicitud</h2>
            </Modal.Header>
            <Modal.Body className="max-h-[65vh]">
                {status === 'loading' && <Message>Cargando histórico...</Message>}
                {status === 'error' && <Message>No se pudo cargar el histórico.</Message>}
                {status === 'ready' && timeline.length === 0 && <Message>Sin movimientos registrados.</Message>}
                {status === 'ready' && timeline.length > 0 && (
                    <div className="relative">
                        <div className="absolute left-[13px] top-4 bottom-4 w-0.5 bg-colorfifth" />
                        {timeline.map((event) => <TimelineEvent key={event.id} event={event} />)}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="!justify-center !border-0">
                <button className="px-4 py-2 rounded-md text-white bg-colorprimary hover:bg-colorsecondary" onClick={onHide}>
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
};
